module.exports = __webpack_public_path__ + "img/tu-1_04.dd6e87a3.jpg";